module.exports = __webpack_public_path__ + "img/Play.a67b2696.svg";